import { MdArrowForwardIos } from "react-icons/md";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";
import "swiper/css";
import { Link } from "react-router-dom";
import MoviesCarousel from "./MoviesCarousel";
import { useSelector } from "react-redux";
import React from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";

export const SectionCarousels = ({
  title,
  link,
  movieType,
  isFirebaseMovie = false,
  genreType = `movies`,
}) => {
  const moviesIndex = [...Array(8).keys()];
  // const moviesTypes = ["indianMovies", "marathiMovies", "trendingTvShows", "actionMovies", "animationMovies", "mysteryMovies", "crimeMovies"];
  const movies = useSelector((state) => state.movies[movieType]);
  const [firebaseMovies, setFirebaseMovies] = React.useState([]);
  React.useEffect(() => {
    const fetchFirebaseMovies = async () => {
      try {
        const moviesCollection = collection(db, "UPLOADS");
        const movieSnapshot = await getDocs(moviesCollection);
        const moviesList = movieSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setFirebaseMovies(moviesList);
        console.log("Firebase movies:", moviesList);
      } catch (error) {
        console.error("Error fetching Firebase movies:", error);
      }
    };

    fetchFirebaseMovies();
  }, []);

  return (
    <div className="relative z-20 mx-3 mt-8 h-fit w-screen">
      <div className="relative flex items-start justify-start gap-2 p-2">
        <span className="relative mx-3 h-fit w-fit text-[2.2rem] font-bold text-white">
          {title}
        </span>
        <span className="relative pt-4 text-2xl">
          <Link
            to={isFirebaseMovie ? `/${link}` : `/discover?${genreType}=${link}`}
          >
            <button>
              <MdArrowForwardIos fill="white" />
            </button>
          </Link>
        </span>
      </div>
      <div className="relative flex h-fit w-full flex-nowrap space-x-4 p-3">
        <Swiper
          spaceBetween={10}
          slidesPerView={"4"}
          direction="horizontal"
          modules={[Mousewheel]}
          mousewheel={{ releaseOnEdges: true }}
          className="h-[25vh] w-full"
        >
          {isFirebaseMovie
            ? firebaseMovies.slice(0, 8).map((movieURL, index) => (
                <SwiperSlide
                  key={index}
                  className="relative h-[25vh] w-[25vw] flex-shrink-0 overflow-hidden rounded-2xl border-white shadow-md shadow-black hover:border-2"
                >
                  <MoviesCarousel
                    movie={movieURL}
                    isFirebaseMovie={isFirebaseMovie}
                  />{" "}
                </SwiperSlide>
              ))
            : moviesIndex.map((index) => (
                <SwiperSlide
                  key={index}
                  className="relative max-h-[25vh] w-[25vw] flex-shrink-0 overflow-hidden rounded-2xl border-white shadow-md shadow-black hover:border-2"
                >
                  <MoviesCarousel
                    movie={movies[index]}
                    isFirebaseMovie={isFirebaseMovie}
                  />
                </SwiperSlide>
              ))}
        </Swiper>
      </div>
    </div>
  );
};
